import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const EditMilkingSchedule = { auth: [...authRoles.admin, ...authRoles.producer], routes: [{ path: '/edit-milking-schedule/:processor_id', component: FuseLoadable({ loader: () => import('./MutateMilkingSchedule') }) }] };

export default [EditMilkingSchedule];
